/**
 * Metadata about a column in a search result
 */
export class HisColumnMetadata {
    id: string;
    label: string;
    visible = true;

    // the following attributes are not really used yet
    dataType: string;
    format: string;
    width: string; // e.g. '34px'
    filterable?: boolean = true;
    sortable?: boolean;
    editable?: boolean;
    sortPath: string;
    filterPath: string;
    renderer?: ( ( component: any, ri: number, row: any[] ) => string );
}
